export class Toast {
	_timeout
	_element
	static INFO = 'info'
	static WARN = 'warn'
	static ERROR = 'error'
	static _openToasts = new Map()

	constructor(target, text, clazz, timeoutSec) {
		this._target = document.getElementById(target)
		// Prevent duplicates
		if (Toast._openToasts.has(text)) {
			Toast._openToasts.get(text).dismiss()
		}
		Toast._openToasts.set(text, this)

		const spinnerElement = document.createElement('div')
		spinnerElement.classList.add('toast')
		spinnerElement.classList.add('card')
		spinnerElement.classList.add('toast_class_' + clazz)
		if (clazz === Toast.INFO) {
			console.debug(text)
		}
		else if (clazz === Toast.WARN) {
			console.warn(text)
		}
		else if (clazz === Toast.ERROR) {
			console.error(text)
		}
		this._element = this._target.appendChild(spinnerElement)
		this._element.innerHTML = `<div><div>${text}</div><button>OK</button></div>`
		this.okClickedPromise = new Promise(resolve => this._element.querySelector('button').addEventListener('click', () => {
			this.dismiss()
			resolve()
		}))
		if (timeoutSec > 0) {
			this._timeout = setTimeout(this.dismiss, timeoutSec * 1000)
		}
	}

	dismiss = () => {
		if (this._timeout) {
			clearTimeout(this._timeout)
			this._timeout = null
		}
		this._element.remove()
	}
}